import * as React from "react";
const DeliveryIndicatorContext = React.createContext(
  {}
);
const useDeliveryIndicator = () => React.useContext(DeliveryIndicatorContext);
function withDeliveryIndicator(Component) {
  const wrappedName = Component.displayName || Component.name || "Component";
  const WithDeliveryIndicator = (props) => /* @__PURE__ */ React.createElement(DeliveryIndicatorContext.Consumer, null, (context) => /* @__PURE__ */ React.createElement(Component, { ...props, config: context?.config }));
  WithDeliveryIndicator.displayName = `WithDeliveryIndicator(${wrappedName})`;
  return WithDeliveryIndicator;
}
export {
  DeliveryIndicatorContext as default,
  useDeliveryIndicator,
  withDeliveryIndicator
};
//# sourceMappingURL=context.js.map
